import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class BlairstoneQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote dault-fg tile is-5"}>
        {` Walking the line between interior design and brand identity, Blairstone uses the framework of pattern to draw intuitive connections and create relationships between otherwise disparate ideas.`}
      </div>
    );
  }
}

export class BlairstoneBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider dault-bg"} />

        <div className={"collabs-section white white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"Kate Blairstone"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/blairstone/blairstone_01.png", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>Kate Blairstone</h1>
            <p>Kate Blairstone’s work investigates pattern as expression of culture and identity, using ingredients and color as symbols for people and places.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>Deeply inspired by the landscape of the West and its overlapping cultural influences, she particularly enjoys layering artifacts, plants and animals to create complex visual recipes.</p>

            <p>Walking the line between interior design and brand identity, Blairstone uses the framework of pattern to draw intuitive connections and create relationships between otherwise disparate ideas. Through collection, curation, and thoughtfully combining elements in a new context, she uses textiles to build an immersive, layered narrative.</p>

            <p>Her large scale, organic designs are painted by hand with Indian ink on layers of tissue paper, then scanned, stacked and colored digitally: a modern update on traditional printmaking. For her collaboration with Weft, Blairstone maximized the differences in value between different weave structures in order to push the potential number of colors within each design, resulting in dimensional, illustrative motifs that resound with life.</p>
          </div>
        </div>
      </div>
    );
  }
}
